import Portal from '@mui/material/Portal';

import { Iconify } from '../iconify';
import { SnackbarRoot } from './styles';
import { snackbarClasses } from './classes';
import { DEFAULT_TOAST_POSITION } from './constants';

// ----------------------------------------------------------------------

export function Snackbar() {
  return (
    <Portal>
      <SnackbarRoot
        expand
        gap={12}
        closeButton
        offset={16}
        visibleToasts={4}
        position={DEFAULT_TOAST_POSITION}
        className={snackbarClasses.root}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast: `${snackbarClasses.toast} data-test-id-toast`,
            icon: snackbarClasses.icon,
            // content
            content: snackbarClasses.content,
            title: `${snackbarClasses.title} data-test-id-toast-title`,
            description: snackbarClasses.description,
            // button
            actionButton: snackbarClasses.actionButton,
            cancelButton: snackbarClasses.cancelButton,
            closeButton: snackbarClasses.closeButton,
            // state
            default: snackbarClasses.default,
            info: snackbarClasses.info,
            error: snackbarClasses.error,
            success: snackbarClasses.success,
            warning: snackbarClasses.warning,
          },
        }}
        icons={{
          loading: <span className={snackbarClasses.loadingIcon} />,
          info: <Iconify className={snackbarClasses.iconSvg} icon="lucide:info" />,
          success: <Iconify className={snackbarClasses.iconSvg} icon="lucide:circle-check" />,
          warning: <Iconify className={snackbarClasses.iconSvg} icon="lucide:triangle-alert" />,
          error: <Iconify className={snackbarClasses.iconSvg} icon="lucide:octagon-alert" />,
        }}
      />
    </Portal>
  );
}
